// extracted by mini-css-extract-plugin
export var headerCell = "_1f-1";
export var loadingSpinnerContainer = "_1f-4";
export var rowWrapper = "_1f-3";
export var standaloneTable = "_1f-5";
export var table = "_1f-0";
export var white = "_1f-2";